import React, { useEffect, useState } from "react";
import { getAllGeneralLedger } from "../../api/endpoints/search";
import { authSelector } from "../../store/selectors/index";
import { useSelector } from "react-redux";
import { Modal, message, Select } from "antd";
import { AiFillSave } from "react-icons/ai";
import { AiFillDelete } from "react-icons/ai";
import { LuView } from "react-icons/lu";
import { AiFillEdit } from "react-icons/ai";
import { AiFillFileAdd } from "react-icons/ai";
import { BiExit } from "react-icons/bi";
import SideBar from "../sidebar/sideBar";
import "./booking.css";
import {
  createBooking,
  updateSingleAccount,
  getAllBookings,
  deleteSingleAccount,
} from "../../api/endpoints/booking";
const { Option } = Select;

const Booking = () => {
  const { user, access_token } = useSelector(authSelector);
  const [fieldsShow, setFieldsShow] = useState(false);
  const [itemsQueue, setItemsQueue] = useState([]);
  const [type, setType] = useState("ADD");
  const today = new Date().toISOString().split("T")[0];

  const [state, setState] = useState({
    parties: [],
    glDescription: "",
    ledgerCodes: [],
    Bookings: [],
    bookingId: "",
    glCode: "",
    CName: "",
    description: "",
    totalPersons: "",
    // TDate: "",
    TDate: today,
    EventDate: "",
    CPRSN: "",
    Address: "",
    phone: "",
    eventType: "",
    Event: "",
    email: "",
    Advance: "",
    Balance: "",
    TotalAmount: "",
  });

  const clearState = () => {
    setState({
      id: "",
      ledgerCodes: state.ledgerCodes,
      parties: state.parties,
      Bookings: state.Bookings,
      partyId: "",
      partyName: "",
      bookinId: "",
      glCode: "",
      glDescription: "",
      eventType: "",
      address: "",
      phone: "",
      email: "",
      partyType: "",
      billType: "",
      billTime: "",
      description: "",
      totalPersons: "",
      billSummary: "",
      unBilledBalence: "",
      billedBalence: "",
      closed: "",
      suspended: "",
    });
    setItemsQueue([]);
  };
  const onChangeText = (e, object) => {
    let name, value;

    if (object) {
      ({ name, value } = object);
    } else {
      ({ name, value } = e.target);
    }

    // Convert numeric values safely
    const numValue = parseFloat(value) || 0;

    // Create a copy of state
    let updatedState = {
      ...state,
      [name]: value,
    };

    // If TotalAmount or Advance changes, recalculate Balance
    if (name === "TotalAmount" || name === "Advance") {
      const total =
        parseFloat(name === "TotalAmount" ? numValue : state.TotalAmount) || 0;

      const advance =
        parseFloat(name === "Advance" ? numValue : state.Advance) || 0;

      updatedState.Balance = total - advance;
    }

    setState(updatedState);
  };

  // const onChangeText = (e, object) => {
  //   if (object) {
  //     const { name, value } = object;
  //     setState({
  //       ...state,
  //       [name]: value,
  //     });
  //   } else {
  //     const { name, value } = e.target;
  //     setState({
  //       ...state,
  //       [name]: value,
  //     });
  //   }
  // };
  const addTank = async () => {
    setType("SAVE");
    setFieldsShow(true);
  };
  //   console.log(state.generalLedgerCode.length,"leng")
  const saveTank = async (e) => {
    if (
      !state.CName ||
      !state.Event ||
      !state.TDate ||
      !state.EventDate ||
      !state.TotalAmount
    ) {
      return message.error(
        `Please type ${
          !state.CName
            ? "Customer Name"
            : !state.Event
              ? "Event"
              : !state.TDate
                ? "Date"
                : !state.EventDate
                  ? "Event Date"
                  : !state.TotalAmount
                    ? "Total Amount"
                    : !state.glCode
                    ? "GL CODE"
                    : ""
        }`
      );
    }

    const payload = {
      CName: state.CName,
      TDate: state.TDate,
      Phone: state.phone,
      Email: state.email,
      EventDate: state.EventDate,
      Address: state.Address,
      CPRSN: state.CPRSN,
      eventType :state.eventType,
      totalPersons :state.totalPersons,
      description :state.description,
      GLCode: state.glCode,
      Event: state.Event,
      TotalAmount: Number(state.TotalAmount),
      Advance: Number(state.Advance),
      Balance: Number(state.Balance),
      grpId: Number(user.grpId),
      siteId: Number(user.siteId),
    };

    const results = await createBooking(payload, access_token);
    if (results.success) {
      message.success(results.message || "Successfully entered!");
      clearState();
      setFieldsShow(false);
      setType("ADD");
    } else {
      message.error(results.message);
    }
  };

  const getAllData = async () => {
    const _bookings = await getAllBookings(access_token);
    const _ledgerCodes = await getAllGeneralLedger(access_token);
    setState({
      ...state,
      Bookings: _bookings,
      ledgerCodes: _ledgerCodes,
    });
  };
  useEffect(() => {
    getAllData();

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const editTank = async () => {
    setType("EDIT");
    setFieldsShow(true);
  };

  const saveEditTank = async (e) => {
    if (type === "EDIT") {
      if (
        !state.CName ||
        !state.Event ||
        !state.TDate ||
        !state.EventDate ||
        !state.TotalAmount
      ) {
        return message.error(
          `Please type ${
            !state.CName
              ? "Customer Name"
              : !state.Event
                ? "Event"
                : !state.TDate
                  ? "Date"
                  : !state.EventDate
                    ? "Event Date"
                    : !state.TotalAmount
                      ? "Total Amount"
                      : ""
          }`
        );
      }
      const data = {
        BookingID: state.bookingId,
        CName: state.CName,
        TDate: state.TDate,
        Phone: state.phone,
        Email: state.email,
        description: state.description,
        eventType: state.eventType,
        totalPersons: state.totalPersons,
        EventDate: state.EventDate,
        Address: state.Address,
        CPRSN: state.CPRSN,
        Event: state.Event,
        TotalAmount: Number(state.TotalAmount),
      };
      console.log(data, "edite data");
      const results = await updateSingleAccount(data, access_token);
      if (results.success) {
        message.success(results.message || "Successfully Updated!");
        clearState();
        setFieldsShow(false);
        setType("ADD");
      } else {
        message.error(results.message);
      }
    } else {
      if (!state.bookingId) return message.error("Please Select Booking");
      modal.confirm({
        title: `Confirm`,
        content: "Are you sure you want to delete this Booking?",
        okText: "Delete",
        cancelText: "Cancel",
        onOk: confirmDeleteNozel,
      });
    }
  };
  const confirmDeleteNozel = async () => {
    const data = {
      BookingID: state.bookingId,
    };
    const results = await deleteSingleAccount(data, access_token);
    if (results.success) {
      message.success(results.message || "Deleted Successfully!");
      clearState();
      setFieldsShow(false);
      setType("ADD");
    } else {
      message.error(results.message);
    }
  };

  const [modal, contextHolder] = Modal.useModal();
  const deleteNozel = async () => {
    setType("DELETE");
    setFieldsShow(true);
  };
  const confirmDelete = () => {
    modal.confirm({
      title: `Confirm`,
      content: "You want to delete Booking?",
      okText: "Yes",
      cancelText: "Cancel",
      onOk: deleteNozel,
    });
  };

  const clearStates = () => {
    clearState();
    setFieldsShow(false);
    setType("ADD");
  };

  const editHandler = async (e) => {
    let results;
    // = await getAllParty(access_token);

    const payload = results.reduce((acc, curr) => {
      return [
        ...acc,
        {
          partyId: curr.partyId,
          partyName: curr.partyName,
          generalLedgerCode: curr.generalLedgerCode,
          description: curr.chartOfAccount.description,
        },
      ];
    }, []);

    setItemsQueue(payload);
  };

  return (
    <>
      <div className="flex bg-black main">
        <SideBar />
        <div className="h-full  flex flex-col content-center  w-full">
          <div className="flex justify-center">
            <div className="meterTableMain flex flex-col justify-items-center justify-center w-1/2 ml-10 mt-5 mr-10">
              <div className="bg-blue-500 headingBox flex justify-center">
                <h1 className="text-white">Booking</h1>
                {contextHolder}
              </div>
              <div className="p-2 flex justify-center">
                {fieldsShow && (
                  <div className="w-70">
                    {type === "EDIT" || type === "DELETE" ? (
                      <>
                        <label className="text-white" htmlFor="fname">
                          Booking ID:
                        </label>
                        <Select
                          className="bg-black text-slate-400 inpTxt  h-8 w-full"
                          showSearch
                          placeholder=""
                          optionFilterProp="children"
                          value={state.bookingId || ""}
                          onChange={(e) => {
                            const _accountInfo = state.Bookings.find(
                              (el) => el.BookingID === e
                            );
                            console.log("e", _accountInfo);

                            setState({
                              ...state,
                              bookingId: e,
                              CName: _accountInfo.CName,
                              TDate: _accountInfo.TDate,
                              Address: _accountInfo.Address,
                              phone: _accountInfo.Phone,
                              email: _accountInfo.Email,
                              CPRSN: _accountInfo.CPRSN,
                              Event: _accountInfo.Event,
                              EventDate: _accountInfo.EventDate,
                              eventType: _accountInfo.eventType,
                              totalPersons: _accountInfo.totalPersons,
                              description: _accountInfo.description,
                              Advance: _accountInfo.Advance,
                              TotalAmount: _accountInfo.TotalAmount,
                            });
                          }}
                        >
                          {state.Bookings.map((el) => (
                            // console.log(el, "el")
                            <Option value={el.BookingID}>
                              {`${el.BookingID} - ${el.CName}`}
                            </Option>
                          ))}
                        </Select>
                      </>
                    ) : (
                      <></>
                    )}
                    <div className="flex justify-evenly w-full">
                      <div className="w-1/2 mb-3">
                        <label className="text-white" htmlFor="fname">
                          Date :
                        </label>
                        <input
                          type="date"
                          name="TDate"
                          value={state.TDate}
                          onChange={onChangeText}
                          className="bg-black text-white inpTxt p-2 h-8 w-full"
                        />
                      </div>
                      <div className="w-1/2 mb-3">
                        <label className="text-white ml-3" htmlFor="fname">
                          Name :
                        </label>
                        <input
                          type="text"
                          name="CName"
                          value={state.CName}
                          onChange={onChangeText}
                          className="bg-black text-white inpTxt p-2 h-8 w-full ml-3"
                        />
                      </div>
                    </div>
                    <div className="flex justify-evenly w-full">
                      <div className="w-1/2 mb-3">
                        <label className="text-white" htmlFor="fname">
                          Phone :
                        </label>
                        <input
                          type="number"
                          name="phone"
                          value={state.phone}
                          onChange={onChangeText}
                          className="bg-black text-white inpTxt p-2 h-8 w-full"
                        />
                      </div>
                      <div className="w-1/2 mb-3">
                        <label className="text-white ml-3" htmlFor="fname">
                          Email :
                        </label>
                        <input
                          type="email"
                          name="email"
                          value={state.email}
                          onChange={onChangeText}
                          className="bg-black text-white inpTxt p-2 h-8 w-full ml-3"
                        />
                      </div>
                    </div>
                    <div className="flex justify-evenly w-full">
                      <div className="w-1/2 mb-3">
                        <label className="text-white" htmlFor="fname">
                          Address :
                        </label>
                        <input
                          type="text"
                          name="Address"
                          value={state.Address}
                          onChange={onChangeText}
                          className="bg-black text-white inpTxt p-2 h-8 w-full"
                        />
                      </div>
                      <div className="w-1/2 mb-3 ml-3">
                        <label className="text-white" htmlFor="fname">
                          Menu :
                        </label>
                        <input
                          type="text"
                          name="CPRSN"
                          value={state.CPRSN}
                          onChange={onChangeText}
                          className="bg-black text-white inpTxt p-2 h-8 w-full"
                        />
                      </div>
                    </div>
                    <div className="flex justify-evenly w-full">
                      <div className="w-full mb-3 ml-3">
                        <label className="text-white" htmlFor="fname">
                          Description :
                        </label>
                        <input
                          type="text"
                          name="description"
                          value={state.description}
                          onChange={onChangeText}
                          className="bg-black text-white inpTxt p-2 h-8 w-full"
                        />
                      </div>
                    </div>
                    <div className="flex justify-evenly w-full">
                      <div className="w-1/2 mb-3">
                        <label className="text-white" htmlFor="fname">
                          Event :
                        </label>
                        <Select
                          showSearch
                          className="text-black inpTxt  h-9 w-full"
                          placeholder=""
                          optionFilterProp="children"
                          value={state.Event} // Set to "Monthly" if state.billTime is falsy
                          onChange={(value) => {
                            onChangeText({
                              target: { name: "Event", value },
                            });
                          }}
                        >
                          <Option value={"Morning"} name="billTime">
                            Morning
                          </Option>
                          <Option value={"Evening"} name="billTime">
                            Evening
                          </Option>
                          <Option value={"Night"} name="billTime">
                            Night
                          </Option>
                        </Select>
                      </div>
                      <div className="w-1/2 mb-3">
                        <label className="text-white ml-3" htmlFor="fname">
                          Event Date :
                        </label>
                        <input
                          type="date"
                          name="EventDate"
                          value={state.EventDate}
                          onChange={onChangeText}
                          className="bg-black text-white inpTxt p-2 h-8 w-full ml-3"
                        />
                      </div>
                    </div>
                    <div className="flex justify-evenly w-full">
                      <div className="w-1/2 mb-3">
                        <label className="text-white" htmlFor="fname">
                          Event Type :
                        </label>
                        <Select
                          showSearch
                          className="text-black inpTxt  h-9 w-full"
                          placeholder=""
                          optionFilterProp="children"
                          value={state.eventType} // Set to "Monthly" if state.billTime is falsy
                          onChange={(value) => {
                            onChangeText({
                              target: { name: "eventType", value },
                            });
                          }}
                        >
                          <Option value={"Per Head"} name="billTime">
                            Per Head
                          </Option>
                          <Option value={"Service"} name="billTime">
                            Service
                          </Option>
                          <Option value={"Cooking & Service"} name="billTime">
                            Cooking & Service
                          </Option>
                        </Select>
                      </div>
                      <div className="w-1/2 mb-3">
                        <label className="text-white ml-3" htmlFor="fname">
                          Total Persons :
                        </label>
                        <input
                          type="number"
                          name="totalPersons"
                          value={state.totalPersons}
                          onChange={onChangeText}
                          className="bg-black text-white inpTxt p-2 h-8 w-full ml-3"
                        />
                      </div>
                    </div>
                    <div className="flex justify-evenly w-full">
                      <div className="w-1/2 mb-3">
                        <label className="text-white" htmlFor="fname">
                          Total Amount :
                        </label>
                        <input
                          type="text"
                          name="TotalAmount"
                          value={state.TotalAmount}
                          onChange={onChangeText}
                          className="bg-black text-white inpTxt p-2 h-8 w-full"
                        />
                      </div>
                      <div className="w-1/2 mb-3 ml-3">
                        <label className="text-white" htmlFor="fname">
                          Advance :
                        </label>
                        <input
                          type="text"
                          name="Advance"
                          value={state.Advance}
                          onChange={onChangeText}
                          className="bg-black text-white inpTxt p-2 h-8 w-full"
                        />
                      </div>
                    </div>
                    <div className="flex justify-evenly w-full">
                      {/* <div className="w-1/2 mb-3">
                        <label className="text-white" htmlFor="fname">
                          Remaining Balance :
                        </label>
                        <input
                          readOnly
                          name="Balance"
                          value={state.TotalAmount - state.Advance}
                          className="bg-black text-white inpTxt p-2 h-8 w-full"
                        />
                      </div> */}

                    </div>
                                        <div className="flex justify-evenly w-full">
                                          <div className="w-1/2 mb-3">
                                            <label className="text-white" htmlFor="fname">
                                              GL Description :
                                            </label>
                                            <Select
                                              showSearch
                                              className="text-black inpTxt  h-9 w-full"
                                              placeholder="GL Description"
                                              optionFilterProp="children"
                                              value={state.glDescription || "GL Description "}
                                              onChange={(e) => {
                                                const lCode = state.ledgerCodes.find(
                                                  (el) => el.CODE === e
                                                );
                                                setState({
                                                  ...state,
                                                  glCode: e,
                                                  glDescription: lCode.Description,
                                                });
                                              }}
                                            >
                                              {state.ledgerCodes.map((el) => (
                                                <Option value={el.CODE}>{el.Description}</Option>
                                              ))}
                                            </Select>
                                          </div>
                                          <div className="w-1/2 mb-3">
                                            <label className="text-white ml-3" htmlFor="fname">
                                              GL Code :
                                            </label>
                                            <Select
                                              showSearch
                                              className="text-black inpTxt  h-9 w-full ml-3"
                                              placeholder="Credit GL Code"
                                              optionFilterProp="children"
                                              value={state.glCode || "Credit GL Code"}
                                              onChange={(e) => {
                                                const lCode = state.ledgerCodes.find(
                                                  (el) => el.CODE === e
                                                );
                                                setState({
                                                  ...state,
                                                  glCode: e,
                                                  glDescription: lCode.Description,
                                                });
                                              }}
                                            >
                                              {state.ledgerCodes.map((el) => (
                                                <Option value={el.CODE}>{el.CODE}</Option>
                                              ))}
                                            </Select>
                                          </div>
                                        </div>
                  </div>
                )}
              </div>
              <div class="flex justify-center pb-3">
                {type === "ADD" && (
                  <button
                    onClick={addTank}
                    className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 py-1 px-4 rounded"
                  >
                    <AiFillFileAdd className="mr-2 mt-1" />

                    <span>Add</span>
                  </button>
                )}

                {type === "SAVE" && (
                  <button
                    onClick={saveTank}
                    className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 py-1 px-4 rounded"
                  >
                    <AiFillSave className="mt-1 mr-2 " />
                    <span>Save</span>
                  </button>
                )}
                {type === "ADD" && (
                  <button
                    onClick={editHandler}
                    className="bg-blue-500 hover:bg-blue-700 flex text-white ml-2 mt-3 py-1 px-4 rounded"
                  >
                    <LuView className="mt-1 mr-2 " />
                    <span>View</span>
                  </button>
                )}
                {type === "ADD" && (
                  <button
                    onClick={editTank}
                    className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 ml-3 py-1 px-4 rounded"
                  >
                    <AiFillEdit className="mr-2 mt-1" />

                    <span>Edit</span>
                  </button>
                )}

                {(type === "EDIT" || type === "DELETE") && (
                  <button
                    onClick={saveEditTank}
                    className="bg-blue-500 hover:bg-blue-700 text-white ml-2 mt-3 py-1 px-4 rounded"
                  >
                    DONE
                  </button>
                )}
                {type === "ADD" && (
                  <button
                    onClick={confirmDelete}
                    className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 ml-3 py-1 px-4 rounded"
                  >
                    <AiFillDelete className="mr-2 mt-1" />

                    <span>Delete</span>
                  </button>
                )}
                {type !== "ADD" && (
                  <button
                    onClick={clearStates}
                    className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 ml-3 py-1 px-4 rounded"
                  >
                    <BiExit className="mr-2 mt-1" />
                    <span>Exit</span>
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Booking;
